import { createAction, props } from '@ngrx/store';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';
import {UUID} from '../../../shared/types/uuid.type';

export const startVmixServer = createAction(
  '[StartVmixServer] Start Vmix Server',
  props<{ id: UUID }>()
);

export const startVmixServerSuccess = createAction(
  '[StartVmixServer] Start Vmix Server Success',
  props<{ data: ProductionInstance }>()
);

export const startVmixServerFailure = createAction(
  '[StartVmixServer] Start Vmix Server Failure',
  props<{ error: any }>()
);

export const clearStartVmixServerState = createAction(
  '[StartVmixServer] Clear Start Vmix Server State',
);
